"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("@mui/material/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports["default"] = function _default(path, name) {
  return (0, _utils.createSvgIcon)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: path
  }), name);
};